import { makeStyles } from '@material-ui/core'

const styles = makeStyles(() => ({
  typographySubtitle: {
    textAlign: 'center',
    fontWeight: 400,
  },
  recaptchaContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
}))

export default styles
